import { Button, Text } from '@postenbring/hedwig-react'
import './h1-display-and-lead.scss';

export const HeaderAndLead = ({ alignClass, headingText, linkText, textField, url }) => (
   <div className={'header-and-lead ' + alignClass}>
      {headingText &&
         <Text variant="h1-display" className="hds-mb-48-64 hds-mt-48-64">
            {headingText}
         </Text>
         }
         {textField && 
         <Text variant="h3" as="p" className="hds-mb-48-64">
            {textField}
            </Text>
         }
         {linkText && 
         <Button variant="primary" className="hds-mb-20-24" asChild>
            <a href={url}>{linkText}</a>
            </Button>
            }
   </div>
)